import React from 'react';
import { Link } from 'react-router-dom';

// Breadcrumb item interface
interface BreadcrumbLink {
  name: string;
  url: string;
}

// Props interface
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: BreadcrumbLink[];
  actions?: React.ReactNode;
}

/**
 * PageHeader component for consistent page headers with breadcrumbs and actions
 */
const PageHeader: React.FC<PageHeaderProps> = ({ 
  title, 
  subtitle, 
  breadcrumbs = [], 
  actions 
}) => {
  return (
    <div className="page-header my-4">
      <div className="d-flex justify-content-between align-items-start mb-2">
        <div>
          <h1 className="mb-1">{title}</h1>
          {subtitle && <p className="text-muted">{subtitle}</p>}
        </div>
        {actions && <div className="page-actions">{actions}</div>}
      </div>
      
      {breadcrumbs.length > 0 && (
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-4">
            {breadcrumbs.map((crumb, index) => {
              const isLast = index === breadcrumbs.length - 1;
              return (
                <li key={index} className={`breadcrumb-item ${isLast ? 'active' : ''}`}>
                  {isLast ? (
                    crumb.name
                  ) : (
                    <Link to={crumb.url}>{crumb.name}</Link>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      )}
    </div>
  );
};

export default PageHeader; 